import { defineMessages } from "react-intl";

const baseId = "t.pages.UsersReference.";

export default defineMessages({
  pageTitle: {
    id: baseId + "pageTitle",
    defaultMessage: "USERS",
  },
});
